import qs from 'qs';
import {http} from './index';
import {AnswerQuestionApi, AssignQuestion, ChangeStudentId, ClaimQuestion, QuestionSource,RejectDetail, SetTopApi, SetVisibleApi, GetAskInputSearch, OssToken,AddlabeApi,GetLabeListApi,GetTaskId,GetTranslateText,BatchClaim,BatchAssign,GetUrlFromLive, BatchTransferToTeach, TeacherClassListTypes} from '@types';
import Axios from 'axios';
import { environment, cookie } from '@gaodun.com/gtools';

export const answerQuestionList = (params: any, options?: {}) => http.get('/teaching-workbench/ask/list', params, options);
export const newAnswerQuestionList = (params: any, options?: {}) => http.get('/teaching-workbench/ask/v2/list', params, options);
export const claimQuestion = (params: ClaimQuestion) => http.put(`/teaching-workbench/ask/receive?askId=${params.askId}`);
export const assignQuestion = (params: AssignQuestion) => http.put('/teaching-workbench/ask/apportion', params);
export const batchAssign = (params:BatchAssign) => http.put('/teaching-workbench/ask/batchApportion',params);
export const detailBaseData = (params: number) => http.get(`/teaching-workbench/ask/${params}`);
export const changeStudentId = (params: ChangeStudentId) => http.post('/olaf/member/detail-list', params);
export const setVisibleApi = (params: SetVisibleApi) => http.put(`/teaching-workbench/ask/${params.askId}/visible?visible=${params.visible}`);
export const setTopApi = (params: SetTopApi) => http.put(`/teaching-workbench/ask/${params.askId}/top?top=${params.top}`);
export const answerQuestionApi = (params: AnswerQuestionApi) => http.post(`/teaching-workbench/ask/${params.askId}/answer`, params);
export const uploadImg = (params: any) => {
    return Axios.post(
        `${environment.getApigateWay()}/base/v1/upload/upload`,
        params,
        {
            headers: {
                'authentication': `Basic ${cookie.getCookie('accessAdmintoken')}`,
                'accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            timeout: 6000000,
        }
    );
}
export const questionSourceApi = (params: QuestionSource) => http.get('/carefree/backend/ask/source/detail', params);
export const batchTransferToTeachApi = (params:BatchTransferToTeach) => http.put('/teaching-workbench/ask/batchTransfer',params);
export const teacherClassListApi = (params:TeacherClassListTypes) => http.post('/teaching-workbench/ask/class/teacherClassList',params);
//根据答疑扩展ID查询审核信息
export const getRejectDetail = (params: RejectDetail) => http.get('teaching-workbench/ask/reject/detail',params);
//学术老师选择驳回问题理由
export const setRejectTeacher = (params: any) => http.post('teaching-workbench/ask/reject/teacher',params);
//同意/拒绝/撤销驳回申请
export const setRejectApply = (params: any) => http.post('teaching-workbench/ask/reject/apply',params);
//提醒审批
export const setRejectApplyRemind = (params: any) => http.post('teaching-workbench/ask/reject/remind/apply',params);
//根据项目id获取学术老师负责人列表
export const getSelectRejectTeachers = (projectId:number) => http.get(`teaching-workbench/qa/config/${projectId}/teachers`);

/**答疑相关搜索接口
 * http://apimock.gaodunwangxiao.com/html/web/controller/share/share.html#5f4db7ceece884256ac408ac
askId	选填	提问id
content	必填	内容
contentType	必填	1 按id 2 问题，追问 3 回答，追答
sourceType	选填	1 相同来源 ，2 不同来源
*/
export const ossTokenApi = (params: OssToken) => http.get('/newoss', params);
export const getAskInputSearch = (params: GetAskInputSearch) => http.get('/teaching-workbench/ask/search',params);
export const getSameSourceTask = (params: any) => http.get(`/teaching-workbench/ask/${params.askId}/same-source`,params);
export const getSameSourceTaskPageable = (params: any) => http.get(`/teaching-workbench/ask/${params.askId}/same-source-v3`,params);
export const getLabelApi = (params:{subject_id:number}) => http.get('ep-backend/exam-syllabus/last-tree',params);
export const addlabeApi = (params:AddlabeApi) => http.post(`/teaching-workbench/tag/ask/${params.askId}`,params.paramsBody);
export const getLabeListApi = (params:GetLabeListApi) => http.post('/ep-backend/knowledgePointRelation/list',params);
export const deleteLabeApi = (params:{id:number,knowledgeId:number,relationId:number}) => http.delete(`/teaching-workbench/tag/ask/${params.id}`,params);
export const getTaskId = (params:GetTaskId) => http.post('/teaching-workbench/ask/answerLink',params);
export const getTranslateText = (params:GetTranslateText) => http.get('/teaching-workbench/ask/answerContent',params);
export const batchClaimApi = (params:BatchClaim) => http.put('/teaching-workbench/ask/batchReceive',params);
export const getTableHeadItem = () => http.get('/teaching-workbench/ask/listHead/query');
export const updateTableHeadItem = (params:{matchHead:string[]}) => http.put('/teaching-workbench/ask/listHead/update',params);
// 查询科目是否开启驳回
export const rejectStatus = (params:{subjectId:number,projectId:number}) => http.get('/teaching-workbench/reject-setting/status',params);

//获取录音文件真实地址
export const getFileTrueUrl = (params:{ callCenterType:string,callId:string}) => http.post('/usopp/api/v1/call-record/record_url',params);
//回复学员评价
export const replyEvaluation = (params: { businessId: string|number, replyContent: string }) => http.post('/teaching-workbench/evaluation/reply', params);

//查询老师回复
export const getReplyDetail = (params: { businessId: number | string }) => http.get(`/teaching-workbench/evaluation/reply/detail/${params.businessId}`);

//修改回复评价
export const updateReply = (params: { businessId: number|string,replyContent:string }) => http.post('/teaching-workbench/evaluation/reply-content/update',params);

// 视频资源判断 是G1 还是G2
export const isG2OrG1VideoTask = (sourceId: any) => http.get('/glive2-vod/api/v1/check/resource', { sourceId });

// 批量不可见
export const groupNoSeeAll = (params:any) => http.put('/teaching-workbench/ask/batch/visible',params);

// 获取题目ai判断
export const getAiFeedBack = (params:any) => http.get('/teaching-workbench/api/v1/feedback', params);

// 提交
export const sendAiFeedBack = (params:any) => http.post('/teaching-workbench/api/v1/feedback/add-answer', params);

// 获取详情
export const getBackDetail = (params:any) => http.get('/teaching-workbench/api/v1/feedback/answer-detail', params);
